export const Form_img = class {
  constructor(header_squares, squares, opt = {}) {
    this.header_squares = header_squares || [];
    this.squares = squares || [];

    this.ratio = opt.ratio;
    this.width = opt.width || 841;
    this.height = opt.height || 1189;
    this.background_color = opt.background_color || '#fff';
    this.border_color = opt.border_color || '#000';
    this.border_width = opt.border_width || 1;
    this.padding_x = opt.padding_x || 0;
    this.padding_y = opt.padding_y || 0;
    this.content_width = this.width - this.padding_x * 2;
    this.content_height = this.height - this.padding_y * 2;
    this.list_side_width = opt.list_side_width || 30;

    Draw_text.font_size = opt.font_size || 16;
    Draw_text.font_family = opt.font_family || 'Microsoft Yahei';
    Draw_text.font_color = opt.font_color || '#000';
    Draw_text.line_height = opt.line_height || 1.3;
    Draw_text.join_str = opt.join_str || " ";
  }
  draw() {
    this.canvas_arr = [];
    this.create_canvas();
    this.draw_squares(this.squares);
    return this.canvas_arr.map(c => c.canvas);
  }
  create_canvas() {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    this.set_ratio(canvas, ctx);
    this.background(ctx);
    this.canvas_arr.push({ canvas, ctx });
    this.cur_ctx = ctx;
    this.auto_draw_init();
    this.draw_header();
  }
  draw_header() {
    this.header_end_y = 0;
    if(!this.header_squares.length) return;
    this.draw_squares(this.header_squares);
    this.auto_draw_next_y();
    this.header_end_y = this.curren_y;
  }
  set_ratio(canvas, ctx) {
    if(!this.ratio) this.ratio = this.get_pixel_ratio(ctx);
    Draw_text.ratio = this.ratio;
    Text_arr.create_canvas(this.ratio);
    canvas.width = this.width * this.ratio;
    canvas.height = this.height * this.ratio;
    ctx.scale(this.ratio, this.ratio);
  }
  get_pixel_ratio(ctx) {
    let backingStore = ctx.backingStorePixelRatio ||
    ctx.webkitBackingStorePixelRatio ||
    ctx.mozBackingStorePixelRatio ||
    ctx.msBackingStorePixelRatio ||
    ctx.oBackingStorePixelRatio ||
    ctx.backingStorePixelRatio || 1;
    return (window.devicePixelRatio || 1) / backingStore;
  }
  background(ctx) {
    ctx.save();
    ctx.fillStyle = this.background_color;
    ctx.fillRect(0, 0, this.width, this.height);
    ctx.restore();
  }
  draw_squares(sq_arr) {
    sq_arr.forEach(sq => {
      this.cur_ctx.save();
      try {
        if(sq.article) {
          this.article_split_to_sq(sq.article).forEach(sub_sq => this.draw_square(sub_sq));
        }
        else this.draw_square(sq);
      }
      catch (e) {
        console.log(e);
        return;
      }
      this.cur_ctx.restore();
    });
  }
  article_split_to_sq(article_content) {
    let article_line = article_content.replace(/<\/p>|<\/h2>|<\/h3>|<\/h4>|<\/ol>|<\/ul>/g, '')
    .split(/<(p|h2|h3|h4|ol|ul)>/).slice(1).reduce((result, cur_str, index) => {
      if(!(index % 2)) result.push({ line_type: cur_str });
      else result.push(Object.assign(result.pop(), { text: cur_str }));
      return result;
    }, [])
    .map(line_obj => {
      if(line_obj.line_type == 'ol') {
        return line_obj.text.split(/<li>|<\/li>/).filter(v => v).map((text, index) => ({
          line_type: line_obj.line_type,
          index: index + 1,
          text: text,
        }));
      }
      if(line_obj.line_type == 'ul') {
        return line_obj.text.split(/<li>|<\/li>/).filter(v => v).map((text) => ({
          line_type: line_obj.line_type,
          text: text
        }));
      }
      return line_obj;
    }).flat();
    return [
      { w: '100%', h: 20, border_width: 0 },
      ...article_line.map(line_obj => {
        switch(line_obj.line_type) {
          case 'h2': return { font_size: 20, align: 'left', padding: 10, text: line_obj.text };
          case 'h3': return { font_size: 18, align: 'left', padding: 10, text: line_obj.text };
          case 'h4': return { font_size: 16, align: 'left', padding: 10, text: line_obj.text };
          case 'p': return { font_size: 14, align: 'left', padding: 7, text: line_obj.text };
          case 'ol': return [
            { w: this.list_side_width, align: 'right', padding: 5, font_size: 14, text: line_obj.index },
            { w: this.content_width - this.list_side_width, align: 'left', padding: 5, font_size: 14, text: line_obj.text },
            { br: true },
          ];
          case 'ul': return [
            { w: this.list_side_width, align: 'right', padding: 5, font_size: 14, text: '●' },
            { w: this.content_width - this.list_side_width, align: 'left', padding: 5, font_size: 14, text: line_obj.text },
            { br: true },
          ];
        }
      }).flat(),
      { w: '100%', h: 30, border_width: 0 },
    ];
  }
  draw_square_auto_height(sq) {
    if(!sq.text && !sq.texts) return;
    // 上字
    if(!sq.w) sq.w = '100%';
    if(typeof sq.w == 'string') sq.w = this.convertPercentage('w', sq.w);
    let temp_canvas = Draw_text.draw(sq.w, 0, sq);
    sq.h = temp_canvas.height / this.ratio;
    let {x, y, w, h} = this.convert_sq_pos_and_size(sq);
    this.cur_ctx.scale(1 / this.ratio, 1 / this.ratio);
    this.cur_ctx.drawImage(temp_canvas, x * this.ratio, y * this.ratio);
    this.cur_ctx.scale(this.ratio, this.ratio);
  }
  draw_square(sq) {
    if(sq.next_page) return this.create_canvas();
    if(sq.br) {
      let end_y_arr = this.auto_drawn_squares.map(sq_pos => sq_pos.end_y);
      this.curren_y = Math.max(...end_y_arr);
      this.curren_x = 0;
      return;
    }
    if(!sq.h) return this.draw_square_auto_height(sq);
    let {x, y, w, h} = this.convert_sq_pos_and_size(sq);
    // 畫框線
    if(sq.border_width !== 0) {
      this.cur_ctx.lineWidth = sq.border_width || this.border_width;
      this.cur_ctx.strokeStyle = sq.border_color || this.border_color;
      this.cur_ctx.strokeRect(x, y, w, h);
    }
    // 上字
    if(sq.text || sq.texts) {
      let temp_canvas = Draw_text.draw(w, h, sq);
      this.cur_ctx.scale(1 / this.ratio, 1 / this.ratio);
      this.cur_ctx.drawImage(temp_canvas, x * this.ratio, y * this.ratio);
      this.cur_ctx.scale(this.ratio, this.ratio);
    }
  }
  convert_sq_pos_and_size(sq) {
    let {x, y, w, h} = sq;
    if(typeof w == 'string') w = this.convertPercentage('w', w);
    if(typeof h == 'string') h = this.convertPercentage('h', h);
    w = Math.min(w, this.content_width);
    h = Math.min(h, this.content_height);
    if(typeof x == 'undefined' && typeof y == 'undefined') {
      if(this.header_end_y + h > this.content_height) {
        throw new Error('height exceeds canvas');
      }
      let auto_pos = this.auto_sq_pos(w, h, sq.not_take_space);
      x = auto_pos.x; y = auto_pos.y;
      if(x) { x -= this.border_width; w += this.border_width; }
      if(y) { y -= this.border_width; h += this.border_width; }
    }
    else {
      if(typeof x == 'string') x = this.convertPercentage('x', x);
      if(typeof y == 'string') y = this.convertPercentage('y', y);
    }
    w -= (sq.border_width || this.border_width);
    h -= (sq.border_width || this.border_width);
    x += (sq.border_width || this.border_width) / 2 + this.padding_x;
    y += (sq.border_width || this.border_width) / 2 + this.padding_y;
    return {x, y, w, h};
  }
  convertPercentage(type, val) {
    if(type == 'x' || type == 'w') return this.content_width * (parseFloat(val) / 100);
    return this.content_height * (parseFloat(val) / 100);
  }
  auto_draw_init() {
    this.auto_drawn_squares = [];
    this.curren_y = 0;
    this.curren_x = 0;
  }
  auto_draw_next_y() {
    let end_y_arr = this.auto_drawn_squares.map(sq_pos => sq_pos.end_y).filter(end_y => end_y > this.curren_y);
    this.curren_y = Math.min(...end_y_arr);
    this.curren_x = 0;
  }
  auto_draw_get_target_x(w, h) {
    if((this.curren_y + h) > this.content_height) {
      this.create_canvas();
    }
    let x_arr = [{start_x: 0, end_x: this.content_width}];
    this.auto_drawn_squares.filter(sq_pos => sq_pos.start_y <= this.curren_y && sq_pos.end_y > this.curren_y)
    .forEach(sq_pos => {
      for(let i = x_arr.length; i--; ) {
        if(x_arr[i].end_x <= sq_pos.start_x || sq_pos.end_x <= x_arr[i].start_x) continue;
        let new_x = [];
        if(x_arr[i].start_x < sq_pos.start_x) new_x.push({start_x: x_arr[i].start_x, end_x: sq_pos.start_x});
        if(sq_pos.end_x < x_arr[i].end_x) new_x.push({start_x: sq_pos.end_x, end_x: x_arr[i].end_x});
        x_arr.splice(i, 1, ...new_x);
      }
    });
    let target_x = x_arr.find(pos_x => {
      return pos_x.start_x >= this.curren_x && (pos_x.start_x + w) <= pos_x.end_x
    });
    if(target_x) {
      this.curren_x = target_x.start_x + w;
      return target_x.start_x;
    }
    this.auto_draw_next_y();
    return this.auto_draw_get_target_x(w, h);
  }
  auto_sq_pos(w, h, not_take_space) {
    let x, y;
    if(this.not_take_space_pos_backup) {
      x = this.not_take_space_pos_backup.x;
      y = this.not_take_space_pos_backup.y;
      this.curren_y = y;
      this.curren_x = x + w;
      this.not_take_space_pos_backup = null;
    }
    else {
      x = this.auto_draw_get_target_x(w, h);
      y = this.curren_y;
    }
    if(not_take_space) {
      this.not_take_space_pos_backup = {x, y};
    }
    else {
      this.auto_drawn_squares.push({
        start_x: x,
        start_y: y,
        end_x: x + w,
        end_y: y + h,
      });
    }
    return {x, y};
  }
}

class Draw_text {
  static create_canvas() {
    Draw_text.canvas = document.createElement('canvas');
    Draw_text.ctx = Draw_text.canvas.getContext('2d');
  }
  static set_width_and_height(w, h) {
    Draw_text.canvas.width = w * Draw_text.ratio;
    Draw_text.canvas.height = h * Draw_text.ratio;
    Draw_text.ctx.scale(Draw_text.ratio, Draw_text.ratio);
  }
  static draw(w, h, opt = {}) {
    let font_size = (opt.font_size || this.font_size);
    let font_family = (opt.font_family || this.font_family);
    let line_height = (opt.line_height || this.line_height) * font_size;
    let text_arr = Text_arr.get_text_arr(w, opt);
    let {x, y_start, align, baseline, after_h} = Draw_text.convert_sq_font_pos(text_arr.length, line_height, w, h, opt);

    Draw_text.set_width_and_height(w, h || after_h);
    Draw_text.ctx.fillStyle = opt.font_color || this.font_color;
    Draw_text.ctx.textAlign = 'left';
    Draw_text.ctx.textBaseline = baseline;
    text_arr.forEach((cur_line, i) => {
      let cur_x = x;
      if(align == 'center') cur_x = x - cur_line.total_w / 2;
      if(align == 'right') cur_x = x - cur_line.total_w;
      cur_line.texts.forEach(text_data => {
        Draw_text.ctx.font = text_data.style + ' ' + font_size + 'px ' + font_family;
        Draw_text.ctx.fillText(text_data.text, cur_x, y_start + line_height * i);
        cur_x += text_data.w;
      });
    });
    return Draw_text.canvas;
  }
  static convert_sq_font_pos(line_count, line_height, w, h, opt) {
    let {align = 'center', baseline = 'middle', padding = 0} = opt;
    if(!h) h = line_height * line_count + padding * 2;
    let x = 0, y_start = 0;
    if(align == 'left') x += padding;
    if(align == 'center') x += w / 2;
    if(align == 'right') x += w - padding;
    if(baseline == 'top') y_start += padding;
    if(baseline == 'middle') y_start = h / 2 + (0.5 - line_count / 2) * line_height;
    if(baseline == 'bottom') y_start = h - (line_count - 1) * line_height - padding;
    y_start += 2;
    return {x, y_start, align, baseline, after_h: h};
  }
}
Draw_text.create_canvas();

class Text_arr {
  static create_canvas(ratio) {
    Text_arr.canvas = document.createElement('canvas');
    Text_arr.ctx = Text_arr.canvas.getContext('2d');
    Text_arr.canvas.width = 100;
    Text_arr.canvas.height = 100;
    Text_arr.ctx.scale(ratio, ratio);
  }
  static set_opt(w, opt) {
    Text_arr.max_w = w - (opt.padding || 0) * 2;
    Text_arr.font_size = opt.font_size || Draw_text.font_size;
    Text_arr.font_family = opt.font_family || Draw_text.font_family;
    Text_arr.line_height = opt.line_height || Draw_text.line_height;
    Text_arr.join_str = opt.join_str || Draw_text.join_str;
  }
  static set_font_style(style) {
    Text_arr.ctx.font = [
      style || '',
      Text_arr.font_size + 'px',
      Text_arr.font_family,
    ].join(' ');
  }
  static get_text_arr(w, opt) {
    Text_arr.set_opt(w, opt);
    if(opt.no_word_wrap && opt.text) return Text_arr.get_text_arr_no_word_wrap(opt.text);
    if(opt.no_word_wrap && opt.texts) return Text_arr.get_text_arr_no_word_wrap(opt.texts.join(Text_arr.join_str));
    if(opt.texts && opt.all_wrap) return Text_arr.get_text_arr_all_wrap_texts(opt.texts);
    if(opt.texts) return Text_arr.get_text_arr_texts(opt.texts);
    return Text_arr.get_text_arr_text(opt.text);
  }
  /* 陣列成員為行 */
  static get_text_arr_no_word_wrap(text) {
    let cur_text_arr = text.toString().replace(/<br>/g, '\n').split('\n')
    .map(line_text => Text_arr.split_style_tags(line_text));
    return Text_arr.test_width(cur_text_arr);
  }
  static get_text_arr_all_wrap_texts(texts) {
    let cur_text_arr = texts.map(text => text.toString().replace(/<br>/g, '\n').split('\n')).flat()
    .map(line_text => Text_arr.split_style_tags(line_text));
    return Text_arr.test_width(cur_text_arr);
  }
  /* 陣列成員為不換行單位 */
  static get_text_arr_texts(texts) {
    let cur_text_arr = texts.map(str => {
      str = str.toString().replace(/<br>/g, '\n');
      return str == '\n' ? str : str.split(/(\n)/);
    }).flat().map(text => Text_arr.split_style_tags(text));
    cur_text_arr = Text_arr.test_width(cur_text_arr);
    cur_text_arr = Text_arr.cur_text_arr_word_wrap(cur_text_arr, true);
    return cur_text_arr;
  }
  static get_text_arr_text(raw_text) {
    raw_text = raw_text.toString().replace(/<br>/g, '\n');
    let cur_text_arr = Text_arr.split_style_tags(raw_text)
    .map(({style, text}) => {
      return text.split('').reduce((arr, cur_str, index) => {
        if(!index) return arr.concat([cur_str]);
        let last_index = arr.length - 1;
        if(!/[^a-z]/i.test(arr[last_index]) && !/[^a-z]/i.test(cur_str)) arr[last_index] += cur_str;
        else arr.push(cur_str);
        return arr;
      }, [])
      .map(text => ([{ style, text }]));
    }).flat();
    cur_text_arr = Text_arr.test_width(cur_text_arr);
    cur_text_arr = Text_arr.cur_text_arr_word_wrap(cur_text_arr);
    return cur_text_arr;
  }
  /* 切開style_tag */
  static split_style_tags(str) {
    let style_tags = ['<strong>', '</strong>', '<b>', '</b>', '<i>', '</i>'];
    let reg = new RegExp('(' + style_tags.join('|') + ')');
    let split_arr = str.toString().split(reg);
    return split_arr.reduce((result, char, index) => {
      if(char == '') return result;
      if(index % 2) {
        switch(char) {
        case '<b>': case '<strong>': result.b = 1; break;
        case '<\/b>': case '<\/strong>': result.b = 0; break;
        case '<i>': result.i = 1; break;
        case '<\/i>': result.i = 0; break;
        }
        result.cur_style = [
          result.b && 'bold',
          result.i && 'italic',
        ].filter(v => v).join(' ');
      }
      else {
        result.arr.push({ style: result.cur_style, text: char })
      }
      return result
    }, { cur_style: '', i: 0, b: 0, arr: [] }).arr;
  }
  /* 測試寬度 */
  static test_width(cur_text_arr) {
    return cur_text_arr.map(texts => {
      let total_w = 0;
      texts.forEach(text_data => {
        Text_arr.test_width_one(text_data);
        total_w += text_data.w;
      });
      return {total_w, texts};
    });
  }
  static test_width_one(text_data) {
    Text_arr.set_font_style(text_data.style);
    text_data.w = Text_arr.ctx.measureText(text_data.text).width;
  }
  /* cur_text_arr自動換行 */
  static cur_text_arr_word_wrap(cur_text_arr, use_join_str) {
    Text_arr.set_font_style('');
    let join_str_w = use_join_str ? Text_arr.ctx.measureText(Text_arr.join_str).width : 0;
    let result = [];
    cur_text_arr.reduce((cur_line, word, index) => {
      if(!index) {
        cur_line_concat(cur_line, word);
        if(index == cur_text_arr.length - 1) result.push(cur_line);
        return cur_line;
      }
      if(word.texts.length == 1 && word.texts[0].text == '\n') {
        result.push(cur_line);
        return { total_w: 0, texts: [] };
      }
      let check_width = cur_line.total_w + word.total_w + join_str_w;
      if(check_width > Text_arr.max_w) {
        result.push(cur_line);
        cur_line = { total_w: 0, texts: [] };
      }
      else if(use_join_str) {
        cur_line_append_child(cur_line, { w: join_str_w, style: '', text: Text_arr.join_str });
      }
      cur_line_concat(cur_line, word);
      if(index == cur_text_arr.length - 1) {
        result.push(cur_line);
      }
      return cur_line;
    }, { total_w: 0, texts: [] });
    return result.filter(cur_line => cur_line.texts.length)
    .map(cur_line => {
      let first_text = cur_line.texts[0];
      first_text.text = first_text.text.replace(/^\s/, '');
      let last_text = cur_line.texts[cur_line.texts.length - 1];
      last_text.text = last_text.text.replace(/\s$/, '');
      cur_line.total_w = 0;
      cur_line.texts.forEach(text_data => {
        Text_arr.test_width_one(text_data);
        cur_line.total_w += text_data.w;
      });
      return cur_line;
    });
    function cur_line_append_child(target_line, child) {
      cur_line_concat(target_line, { total_w: child.w, texts: [child] });
    }
    function cur_line_concat(target_line, child_line) {
      if(target_line.texts == 0) {
        target_line.total_w = child_line.total_w;
        target_line.texts = [].concat(child_line.texts);
        return;
      }
      let last_word = target_line.texts[target_line.texts.length - 1];
      let first_word = child_line.texts[0];
      if(last_word.style == first_word.style) {
        last_word.text += first_word.text;
        Text_arr.test_width_one(last_word);
        child_line.texts.shift();
      }
      target_line.texts = target_line.texts.concat(child_line.texts);
      target_line.total_w = target_line.texts.reduce((w, word) => w + word.w, 0);
    }
  }
}